window.pvaMeasurementResult = null;

window.launchPVAPDMeasurement = function () {
  pvaPDMeasurement.launch("pva-pdmeasurement-container", {
    popup: true,
    apikey: "SqdR5mj3tdMqdgkHefllH5wtDJbOgz3B",

    onGetMeasurementResults: function (result) {
      console.log("PlanetVA result:", result);

      window.pvaMeasurementResult = {
        pd: result.pd || "",
        monopdleft: result.monopdleft || "",
        monopdright: result.monopdright || "",
        facewidth: result.facewidth || ""
      };

      console.log("Resultado salvo globalmente:", window.pvaMeasurementResult);
    }
  });
};

function getPlanetVAProperties() {
  if (!window.pvaMeasurementResult) return null;

  return {
    "PD Total": window.pvaMeasurementResult.pd ?? "",
    "PD Olho Direito": window.pvaMeasurementResult.monopdright ?? "",
    "PD Olho Esquerdo": window.pvaMeasurementResult.monopdleft ?? "",
    "Largura do Rosto": window.pvaMeasurementResult.facewidth ?? ""
  };
}

(function interceptCartAdd() {
  const originalFetch = window.fetch;

  window.fetch = async function(input, init = {}) {
    const url = typeof input === "string" ? input : input?.url;
    const isCartAdd = url && url.includes("/cart/add.js");

    if (isCartAdd && init.body && window.pvaMeasurementResult) {
      try {
        if (typeof init.body === "string") {
          const payload = JSON.parse(init.body);
          const pvaProps = getPlanetVAProperties();

          if (payload.items && Array.isArray(payload.items)) {
            payload.items = payload.items.map((item) => {
              item.properties = {
                ...(item.properties || {}),
                ...pvaProps
              };
              return item;
            });

            init.body = JSON.stringify(payload);

            console.log("PlanetVA properties anexadas ao /cart/add.js:", payload);
          }
        }
      } catch (error) {
        console.error("Erro ao anexar propriedades PlanetVA no cart/add:", error);
      }
    }

    return originalFetch.call(this, input, init);
  };
})();